<template>
    <validation-observer #default="{ invalid }" ref="observer">
        <span class="display-none">{{ invalid }}</span>
        <b-form>
            <PlanInputContent title="B. Scop" warn="Această secțiune trebuie să descrie motivul inițierii proiectului, indicând beneficiile scontate.">
                <template v-slot:body>
                    <div class="textarea">
                        <validation-provider
                            #default="{ errors }"
                            rules="required"
                        >
                            <b-form-textarea
                                v-model="form.scope"
                                rows="4"
                                max-rows="20"
                                :state="errors.length > 0 ? false : null"
                                :readonly="completed"
                                @input="$emit('unsavedChanges', !!form.scope.length)"
                            ></b-form-textarea>
                            <small class="text-danger">{{ errors[0] }}</small>
                        </validation-provider>
                        <b-icon-pencil-square font-scale="1.2"></b-icon-pencil-square>
                    </div>
                </template>
            </PlanInputContent>
            <hr class="mt-5">
            <b-form-checkbox
                v-model="completed"
                switch
                size="lg"
                class="switch-box"
                :disabled="invalid"
                @change="completeForm()"
            >Informațiile sunt complete și corecte</b-form-checkbox>
        </b-form>
    </validation-observer>
</template>

<script>
    import { BForm, BFormInput, BFormCheckbox, BFormTextarea, BIconPencilSquare, BIconCheckCircleFill, BTable, BIconXCircleFill} from "bootstrap-vue";
    import PlanInputContent from '@/pages/Aplicatii/M3/M3Sketch/components/plan-afaceri/PlanInputContent'
    import { ValidationProvider, ValidationObserver } from 'vee-validate'
    require('@/helpers/validations/validations')
    export default {
        components: {
            BForm,
            BFormInput,
            PlanInputContent,
            BFormCheckbox,
            BFormTextarea,
            BIconPencilSquare,
            BIconCheckCircleFill,
            BTable,
            BIconXCircleFill,
            ValidationProvider,
            ValidationObserver
        },
        props: {
            scop: null,
        },
        data() {
            return {
                completed: false,
                companyName: '',
                form: {
                    scope:  null,

                }
            }
        },
        computed: {
            checks() {
                return this.$store.getters['checks/checks'];
            },
            allData() {
                return this.$store.getters['m3Sketch/allData']
            }
        },
        watch: {
            checks: {
                handler: function() {
                    this.completed = this.checks.planDeAfaceriScop;
                    if(this.completed)
                        this.$emit('formComplete')
                    else
                        this.$emit('formIncomplete')
                },
                deep: true,
                immediate: true
            },
            scop: {
                handler() {
                    if(this.scop){
                        this.form.scope = this.scop.business_plan_scope
                    }
                },
                deep: true,
                immediate: true
            }
        },
        mounted() {
            this.companyName = JSON.parse(localStorage.getItem('currentM3Company')).name
            if(!this.form.scope){
                this.form.scope = 'Text autogenerat POC Sketch* - vă rugăm editați \n\n' +
                    'Scopul principal al proiectului reprezinta ameliorarea efectelor provocate de criză în contextul pandemiei de COVID-19 in cadrul ' +
                    this.companyName + '. Proiectul presupune consolidarea poziției pe piață a companiei '+this. companyName +' și pregătirea unei redresări verzi, ' +
                    'digitale și reziliente a economiei prin investiția în activitatea de producție a întreprinderii (și dezvoltarea unui produs nou, inovator, după ' +
                    'caz). Prin implementarea proiectului vor fi diminuate efectele pandemiei COVID-19 și a consecințelor sale la nivelul companiei transpuse prin ' +
                    'scaderea cifrei de afaceri cu '+parseFloat(this.allData ? this.allData.turnover_difference : 0).toFixed(2)+'% in anul 2020 fata de anul 2019.';
            }
        },
        methods: {
            completeForm() {
                this.$refs.observer.validate().then((e) => {
                    if(!e) {
                        this.completed = false
                        this.$toast.error('Te rugăm completează câmpurile marcate cu roșu.');
                    } else{

                        this.formSend = {
                            business_plan_scope: {
                                business_plan_scope: this.form.scope,
                                checked: this.completed
                            }
                        }
                        this.$store.dispatch('m3Sketch/saveAllDataProjectPart', this.formSend)
                            .then((firstResponse) => {
                                this.$toast.success(firstResponse.data)
                                this.$emit('formUpdated', this.form.scope)
                            }).catch((xhr) => {
                                if (xhr.status === 422) {
                                    this.errors.record(xhr.responseJSON.errors);
                                }
                                this.$toast.error(xhr.response.data.message);
                            });
                    }
                })
                if(this.checks.planDeAfaceriScop !== this.completed)
                    this.$store.dispatch('checks/updateChecks', { name: 'planDeAfaceriScop', value: this.completed })
            },
        }
    }
</script>

<style scoped>
.textarea{
    position: relative;
}
.textarea >>> textarea{
    border: 2px solid #9da2b0;
    background: #f8f9f9;
    color: #515679;
}
.textarea >>> textarea:focus{
    box-shadow: 0 0 0 0.2rem #cdfaee;
}
.textarea svg{
    position: absolute;
    top: 10px;
    right: 10px;
    color: #9da2b0;
}
.switch-box{
    text-align: right;
    margin-top: 25px;
}
.switch-box >>> input, .switch-box >>> label{
    cursor: pointer;
}
.switch-box >>> label{
    font-size: 14px !important;
    color: #38393c;
    line-height: 1.9 !important;
}
.textarea >>> textarea:read-only{
    background: #e5fffb;
}
</style>
